
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/examples.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-examples-demo-basic","docs-x-markdown-examples-demo-combined","docs-x-markdown-examples-demo-codehighlighter","docs-x-markdown-examples-demo-supersets","docs-x-markdown-examples-demo-escape-raw-html"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/examples.zh-CN.md?type=demo')
};